import React from 'react';
import { BsChevronRight } from 'react-icons/bs';
import { FaLock } from 'react-icons/fa';
import theme from '../../theme';
import { ModulesI } from '../../types/Class';

import ClassesLengthBadge from '../ClassesLengthBadge';
import ClassProgress from '../ClassesProgress';
import {
  Container,
  ContentImage,
  ContentView,
  Description, Item, ItemContent, Title,
  TitleContainer,
} from './styles';

interface ClassListItemI {
  onPress: () => void
  cover: string
  name: string
  description: string
  executed_percent: number
  courseModules: ModulesI[]
  isLocked?: boolean
}

function ClassListItem({
  onPress, cover, name, description, courseModules, executed_percent, isLocked,
}: ClassListItemI) {
  return (
    <Container
      onClick={onPress}
      data-testid="class-list-item"
    >
      <Item>
        <ContentImage
          style={{ backgroundImage: `url(${cover})` }}
        >
          <ItemContent>
            <ContentView>
              <TitleContainer>
                {isLocked && <FaLock size={14} color={theme.colors.title} style={{ marginRight: 5 }} />}
                <Title>{name}</Title>
              </TitleContainer>
              <ClassesLengthBadge length={courseModules.length} />
            </ContentView>
            <Description>{description}</Description>
            <ClassProgress percentage={executed_percent} />
          </ItemContent>
          <BsChevronRight color={theme.colors.title} size={36} />
        </ContentImage>
      </Item>
    </Container>
  );
}

export default ClassListItem;
